import { render, staticRenderFns } from "./TextBoxForm.vue?vue&type=template&id=afa1a436"
import script from "./TextBoxForm.vue?vue&type=script&lang=js"
export * from "./TextBoxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports